<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <vs-card class="md:w-1/2">
      <form class="md:flex md:space-x-4" role="form" @submit.stop.prevent="buscar">
        <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
        <div class="vx-col w-full">
          <span>Data Inicial</span>

          <datepicker :format="'dd/MM/yyyy'" placeholder="DD/MM/YYYY" v-model="formFiltro.dataInicial"></datepicker>
        </div>

        <div class="vx-col w-full">
          <span>Data Final</span>
          <datepicker :format="'dd/MM/yyyy'" placeholder="DD/MM/YYYY" v-model="formFiltro.dataFinal"></datepicker>
        </div>

        <div class="vx-col w-full">
          <vs-button color="success" type="filled" icon-pack="feather" icon="icon-search" class="mt-4 w-100"
            native-type="submit">Buscar</vs-button>
        </div>
      </form>
    </vs-card>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "./../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import jwt from "jsonwebtoken";
import vSelect from "vue-select";
import service from "../../services";
import BotaoSubmit from "../../components/BotaoSubmit";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
  },
  watch: {
    estado(value) {
      this.formFiltro.estado = value;
      this.formFiltro.cidade = null;
      this.buscaDadosSelectsCidades(
        "domMunicipio",
        "cidades",
        "nomeCidade",
        "idCidade"
      );
    },
  },
  data() {
    return {
      decoded: null,
      aguardeCadastro: false,
      idEmpresa: null,
      estados: [],
      cidades: [],
      grupos: [],
      clientes: [],
      consultores: [],
      status: [],
      languages: lang,
      filtroAvancado: false,
      tiposDatas: ["Data Cadastro", "Data Vistoria"],
      estado: null,
      funcoesValicao: null,
      formFiltro: {
        cidade: "",
        estado: "",
        tipoData: "Data Cadastro",
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        idCliente: null,
      },
    };
  },
  methods: {
    limparFiltro() {
      this.formFiltro = {
        cidade: "",
        estado: "",
        tipoData: "Data Cadastro",
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        idCliente: null,
      };
      this.buscar();
    },
    dataInicio() {
      var date = new Date();
      var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
      return primeiroDia;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          if (array == "status" && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    buscaDadosClientes() {
      service.getAll("Cliente", {}, "Listar/todos").then((res) => {
        res.data.forEach((element) => {
          this.clientes.push({
            id: element.idCliente,
            label: element.nomeFantasia,
          });
        });
      });
    },

    getDecoded() {
      const token = localStorage.getItem("user-token");
      if (token) {
        this.decoded = jwt.decode(token);
      }
    },
    buscaDadosUsuarios() {
      service.getAll("Usuario", {}, "Listar/todos").then((res) => {
        console.log(res.data);
        res.data.forEach((element) => {
          this.consultores.push({
            id: element.idUsuario,
            label: element.nome,
          });
        });
      });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      this.$vs.loading();
      this[array] = [];
      service
        .getAll("g", {}, `${model}/list/codUf/${this.formFiltro.estado.id}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        });
    },
    buscar() {
      this.formFiltro.idEmpresa = this.idEmpresa;
      this.$emit("filtro", this.formFiltro);
    },
  },
  mounted() {
    this.getDecoded();
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
